import { API_URL, setHeader } from 'api';
import axios from 'axios';
import map from 'lodash/map';
import reduce from 'lodash/reduce';

const URL = `${API_URL}/vendor-requests`;

export const fetchAllVendorRequests = params => {
  const req = setHeader(axios);
  return req.get(`${URL}`, { params });
};

export const fetchVendorRequest = vendorRequestID => {
  const params = { vendorRequestID, start: 0, limit: 1, timestamp: new Date().getTime() };
  const req = setHeader(axios);
  return req.get(`${URL}/`, { params });
};

export const fetchVendorRequestHistory = vendorRequestID => {
  const req = setHeader(axios);
  return req.get(`${URL}/history/${vendorRequestID}`);
};

export const updateVendorRequest = (vendorRequestID, body) => {
  const req = setHeader(axios);
  return req.put(`${URL}/${vendorRequestID}`, body);
};

export const rejectPrescreenAnswers = (id, rejectionNote) => {
  const req = setHeader(axios);
  return req.put(`${URL}/${id}/modify`, {
    rejectionNote,
    action: 'REJECT',
  });
};

export const acceptPrescreenAnswers = id => {
  const req = setHeader(axios);
  return req.put(`${URL}/${id}/modify`, {
    action: 'ACCEPT',
    rejectionNote: '',
  });
};

export const fetchVendorDetails = id => {
  const req = setHeader(axios);
  return req.get(`${URL}/vendors/${id}`);
};

export const createVendor = body => {
  const req = setHeader(axios);
  return req.post(`${URL}/vendors`, body);
};

export const updateVendorDetails = (id, body) => {
  const req = setHeader(axios);
  return req.put(`${URL}/vendors/${id}`, body);
};

export const deleteVendor = id => {
  const req = setHeader(axios);
  return req.delete(`${URL}/vendors/${id}`);
};

export const fetchVendorProducts = vendorID => {
  const req = setHeader(axios);
  const params = { vendorID };
  return req.get(`${URL}/products-services`, {
    params,
  });
};

export const fetchAllVendors = () => {
  const req = setHeader(axios);
  return req.get(`${URL}/vendors`);
};

export const fetchVendorContacts = thirdParty => {
  const params = { start: 0, limit: -1, thirdParty, status: 'Active' };
  const req = setHeader(axios);
  return req.get(`${API_URL}/users`, { params });
};

export const fetchRequestComments = id => {
  const req = setHeader(axios);
  return req.get(`${URL}/${id}/comments`);
};

export const renewRequest = (id, body) => {
  const req = setHeader(axios);
  return req.post(`${API_URL}/vendor-requests/renewal/${id}`, body);
};

export const createRequestComment = (id, content) => {
  const req = setHeader(axios);
  return req.post(`${URL}/${id}/comments`, {
    content,
  });
};
export const updateRequestComment = (comment, content) => {
  const { vendorRequestID, vendorRequestCommentID } = comment;
  const req = setHeader(axios);
  return req.put(
    `${URL}/${vendorRequestID}/comments/${vendorRequestCommentID}`,
    {
      content,
    }
  );
};
export const deleteRequestComment = comment => {
  const { userID } = comment.user;
  const { vendorRequestID, vendorRequestCommentID } = comment;

  const req = setHeader(axios);
  return req.delete(
    `${URL}/${vendorRequestID}/comments/${vendorRequestCommentID}`,
    {
      data: { userID },
    }
  );
};

export const updatePrescreeningAnswers = (vendorRequestID, answers, changeReason) => {
  const req = setHeader(axios);
  let body = {answers};
  if(typeof changeReason !== 'undefined' && changeReason !== '')
	body.changeReason = changeReason;
  return req.put(`${API_URL}/prescreening/instance/${vendorRequestID}`, body);
};

export const submitVendorRequest = request => {
  const req = setHeader(axios);
  const {
    sponsor,
    vendorContact,
    prescreen,
    vendorInformation,
    productServiceName,
    description,
    reqPoInvoice,
    departmentsRequesting,
  } = request;
  return req.post(`${URL}`, {
    sponsorInformation: {
      id: sponsor.userID,
      emailAddress: sponsor.email,
    },
    vendorInformation: {
      /* If the ID is NaN, its a new vendor as vendors created during the request process have their ID set to the label value*/
      id: isNaN(vendorInformation.value)
        ? null
        : parseInt(vendorInformation.value, 10),
      name: vendorInformation.label,
    },
	vendorContact: vendorContact.map(vc => { return { // format for the post
		"id": typeof vc.userID !== 'undefined' ? vc.userID : null,
		"firstName": typeof vc.firstName !== 'undefined' ? vc.firstName : null,
		"lastName": typeof vc.lastName !== 'undefined' ? vc.lastName : null,
		"emailAddress": typeof vc.email !== 'undefined' ? vc.email : null
	}}),
    productServiceName: productServiceName.label,
    departmentsRequesting: map(departmentsRequesting, d => d.departmentID),
    description: description,
    reqPoInvoice: reqPoInvoice,
    prescreenResults: mapPrescreenResults(prescreen),
  });
};

const mapPrescreenResults = results => {
  return reduce(
    results,
    (result, val, key) => {
      const value = val.length ? val : new Array(val);
      const answerIDs = map(value, val => val.answerID);
      const questionID = value[0] && value[0].questionID;
      result[key] = { questionID, answerIDs };
      return result;
    },
    []
  );
};

export const submitDepartmentalReview = (review) => {
	const { ReviewID, Response, Comment } = review;
	const req = setHeader(axios);
	
	const params = { ReviewID, Response };
	if(Comment !== null) params.Comment = Comment;

	return req.put(`${URL}/update-review`, params);
};

export const submitSendReviewNotice = (VendorRequestID, DepartmentID) => {
	const req = setHeader(axios);
	return req.get(`${URL}/${VendorRequestID}/send-review-notice/${DepartmentID}`)
};

export const testReviewAPI = (vendorRequestID, whichMail) => {
	const req = setHeader(axios);
	return req.get(`${URL}/test/${vendorRequestID}/${whichMail}`);
};